// extracted by mini-css-extract-plugin
module.exports = {"title":"BC","status":"BD","isRental":"BE"};